/* eslint-disable no-undef */
import { eraseCookie } from "@commonUtils"
import { autoLogin } from "@lib/utils"

import { updateAuthConfig } from "@containers/App/reducer.js"

export const getSessionAndLogin = () => (dispatch) => {
    if (typeof tdlSsoAuth !== "undefined" && Object.keys(tdlSsoAuth).length) {
        return tdlSsoAuth
            .getSession()
            .then((response) => {
                const { authCode, codeVerifier } = response
                if (authCode && codeVerifier) {
                    autoLogin({ code_verifier: codeVerifier, auth_code: authCode }).then((res) => {
                        const userFlags = res.data?.user_flags
                        if (userFlags?.conflict && userFlags?.conflict_data) {
                            const conflictCases = userFlags.conflict_data.map((val) => {
                                return {
                                    value: val.email,
                                    display: val.email,
                                }
                            })

                            dispatch(
                                updateAuthConfig({
                                    populateData: {
                                        optionList: conflictCases,
                                        header: userFlags?.header,
                                        description: userFlags?.description,
                                        cta: userFlags?.cta,
                                        number: userFlags?.number,
                                        conflict: userFlags?.conflict,
                                        requiredDetail: "email",
                                    },
                                    showAuth: true,
                                })
                            )
                        } else if (userFlags?.is_number_required && userFlags?.conflict) {
                            dispatch(
                                updateAuthConfig({
                                    populateData: {
                                        header: userFlags?.header,
                                        description: userFlags?.description,
                                        cta: userFlags?.cta,

                                        conflict: userFlags?.conflict,
                                        conflictEmail: userFlags?.email,
                                        requiredDetail: "phone",
                                    },
                                    showAuth: true,
                                })
                            )
                        } else {
                            location.reload()
                        }
                    })
                }
            })
            .catch((err) => {
                console.dir({
                    service_name: "pwa-dweb-node-server",
                    loglevel: "error",
                    version: "v2",
                    traceback: err,
                })
            })
    } else return Promise.reject("script not loaded")
}

export const updateTdlSsoAuthSession = (param) => () => {
    const { action, accessToken } = param
    if (typeof tdlSsoAuth !== "undefined" && Object.keys(tdlSsoAuth).length) {
        const updateAction =
            action == "login" ? tdlSsoAuth.createSession(accessToken) : tdlSsoAuth.deleteSession(accessToken)
        updateAction.then(() => {
            eraseCookie("tdlSsoAction")
        })
    }
}
